import classNames from "@calcom/lib/classNames";

export default function Logo({
  small,
  icon,
  inline = true,
  className,
}: {
  small?: boolean;
  icon?: boolean;
  inline?: boolean;
  className?: string;
}) {
  return (
    <h3 className={classNames("logo", inline && "inline", className)}>
      <strong>
        {icon ? (
          <img className="mx-auto w-20 dark:invert" alt="Cal" title="Cal" src="/api/logo?type=icon" />
        ) : (
          <img
            className={classNames(small ? "h-20 w-auto" : "h-20 w-auto", "dark:invert")}
            alt="Digital Promise Calendar"
            title="Digital Promise Calendar"
            src="/api/logo"
          />
        )}
      </strong>
    </h3>
  );
}
